import React,{FormEvent, useCallback, useState} from 'react'
import {Link} from 'react-router-dom'
import { LoginAlert } from '../../components/Alerts/LoginAlert'
import useApi from '../../hooks/useApi'
import { SubmitButton } from '../../Korbantech/components/Buttons/SubmitButton'
import { TextInput } from '../../Korbantech/components/Inputs/TextInput'
import { Label } from '../../Korbantech/components/Label'
import { BRAND_LOGO } from '../../utils/constants'

export const ForgotPassword = () => {

    const api = useApi()
    const [sendPassword,setSendPassword] = useState<boolean>()
    const [sendPasswordErr,setSendPasswordErr] = useState<boolean>()

    
    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault()
        e.currentTarget.checkValidity()

        const data = new FormData(e.currentTarget)

        await api.post('/osc/forgot-password',data).then(res => {
            setSendPassword(true)
        }).catch(err => setSendPasswordErr(true))

    }, [api])

    return (
        <div className="bg-brand-bg h-screen w-screen flex flex-col items-center justify-center bg-gray-100">
            {sendPassword && <LoginAlert header={"Recuperar senha"}  text={
                <>
                   Foi enviado uma mensagem para o email cadastrado com uma nova senha.
                </>
            } />
            }
            {sendPasswordErr && <LoginAlert error header={"Recuperar senha"}  text={
                <>
                   Erro ao enviar uma nova senha.
                </>
            } />
            }
        <form className="max-w-xs w-4/5 bg-white border border-gray-300" onSubmit={handleSubmit}>
            <div className="w-full flex flex-col items-center justify-center pt-6">
            <img
                        className='-mb-4'
                        width={120}
                        height="auto"
                        src={BRAND_LOGO}
                        alt="programa impulso"
                    />
                    <div className='text-gray-700 text-lg font-semibold -mb-4'>
                        Recuperar Senha
                    </div>
            </div>
            <div className="bg-white mt-1 p-4 grid grid-cols-1 rounded-lg">
                <div className={`p-3`}>
                    <Label>
                        CNPJ
                        <TextInput className={"border-gray- rounded-lg"} placeholder={"00.000.000/0001-00"} name="document" required />
                        <span className='text-sm text-gray-500'>Informe o CNPJ cadastrado.</span>
                    </Label>
                </div>
                <div>
                </div>
                <div className="center p-2">
                    <SubmitButton className="bg-brand-button text-brand-button-text mt-2" value="Recuperar senha" />
                </div>
            </div>
        </form>
        <div className='mt-2 max-w-xs w-4/5'>
            <Link className='ml-1 font-semibold' to={"/osc/login"}>
                    Voltar para login
            </Link>
        </div>

    </div>
    )
}
